import _regeneratorRuntime from "/codebuild/output/src672/src/s3/00/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/codebuild/output/src672/src/s3/00/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/codebuild/output/src672/src/s3/00/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { transformToNestObject, appendErrors } from 'react-hook-form';

var parseErrorSchema = function parseErrorSchema(error, validateAllFieldCriteria) {
  return Array.isArray(error.inner) ? error.inner.reduce(function (previous, _ref) {
    var path = _ref.path,
        message = _ref.message,
        type = _ref.type;
    return Object.assign(Object.assign({}, previous), path ? previous[path] && validateAllFieldCriteria ? _defineProperty({}, path, appendErrors(path, validateAllFieldCriteria, previous, type, message)) : _defineProperty({}, path, previous[path] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type, message || true)
    } : {})) : {});
  }, {}) : _defineProperty({}, error.path, {
    message: error.message,
    type: error.type
  });
};

var yupResolver = function yupResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, _) {
      var validateAllFieldCriteria,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              validateAllFieldCriteria = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              _context.prev = 1;
              _context.next = 4;
              return schema.validate(values, Object.assign({}, options));

            case 4:
              _context.t0 = _context.sent;
              _context.t1 = {};
              return _context.abrupt("return", {
                values: _context.t0,
                errors: _context.t1
              });

            case 9:
              _context.prev = 9;
              _context.t2 = _context["catch"](1);
              return _context.abrupt("return", {
                values: {},
                errors: transformToNestObject(parseErrorSchema(_context.t2, validateAllFieldCriteria))
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var convertArrayToPathName = function convertArrayToPathName(paths) {
  return paths.reduce(function (previous, path, index) {
    return "".concat(previous).concat(typeof path === 'string' ? "".concat(index > 0 ? '.' : '').concat(path) : "[".concat(path, "]"));
  }, '').toString();
};

var parseErrorSchema$1 = function parseErrorSchema$1(error, validateAllFieldCriteria) {
  return Array.isArray(error.failures) ? error.failures.reduce(function (previous, _ref6) {
    var path = _ref6.path,
        _ref6$message = _ref6.message,
        message = _ref6$message === void 0 ? '' : _ref6$message,
        type = _ref6.type;
    var currentPath = convertArrayToPathName(path);
    return Object.assign(Object.assign({}, previous), path ? previous[currentPath] && validateAllFieldCriteria ? _defineProperty({}, currentPath, appendErrors(currentPath, validateAllFieldCriteria, previous, type || '', message)) : _defineProperty({}, currentPath, previous[currentPath] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type || '', message || true)
    } : {})) : {});
  }, {}) : [];
};

var superstructResolver = function superstructResolver(schema) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, _) {
      var validateAllFieldCriteria,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              validateAllFieldCriteria = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              _context2.prev = 1;
              return _context2.abrupt("return", {
                values: schema(values),
                errors: {}
              });

            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", {
                values: {},
                errors: transformToNestObject(parseErrorSchema$1(_context2.t0, validateAllFieldCriteria))
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 5]]);
    }));

    return function (_x3, _x4) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var parseErrorSchema$2 = function parseErrorSchema$2(error, validateAllFieldCriteria) {
  return Array.isArray(error.details) ? error.details.reduce(function (previous, _ref10) {
    var path = _ref10.path,
        _ref10$message = _ref10.message,
        message = _ref10$message === void 0 ? '' : _ref10$message,
        type = _ref10.type;
    var currentPath = convertArrayToPathName(path);
    return Object.assign(Object.assign({}, previous), path ? previous[currentPath] && validateAllFieldCriteria ? _defineProperty({}, currentPath, appendErrors(currentPath, validateAllFieldCriteria, previous, type, message)) : _defineProperty({}, currentPath, previous[currentPath] || Object.assign({
      message: message,
      type: type
    }, validateAllFieldCriteria ? {
      types: _defineProperty({}, type, message || true)
    } : {})) : {});
  }, {}) : [];
};

var joiResolver = function joiResolver(schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    abortEarly: false
  };
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values, _) {
      var validateAllFieldCriteria,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              validateAllFieldCriteria = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
              _context3.prev = 1;
              _context3.next = 4;
              return schema.validateAsync(values, Object.assign({}, options));

            case 4:
              _context3.t0 = _context3.sent;
              _context3.t1 = {};
              return _context3.abrupt("return", {
                values: _context3.t0,
                errors: _context3.t1
              });

            case 9:
              _context3.prev = 9;
              _context3.t2 = _context3["catch"](1);
              return _context3.abrupt("return", {
                values: {},
                errors: transformToNestObject(parseErrorSchema$2(_context3.t2, validateAllFieldCriteria))
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));

    return function (_x5, _x6) {
      return _ref13.apply(this, arguments);
    };
  }();
};

export { joiResolver, superstructResolver, yupResolver };